import { render, staticRenderFns } from "./ubcElectrochemReportSheetC.vue?vue&type=template&id=6da5bd4e&scoped=true&"
import script from "./ubcElectrochemReportSheetC.vue?vue&type=script&lang=js&"
export * from "./ubcElectrochemReportSheetC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da5bd4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSimpleTable})
